import { HttpResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { WebStorage } from '../../auth/storage/web.storage';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-supply-list',
  templateUrl: './supply-list.component.html',
  styleUrls: ['./supply-list.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class SupplyListComponent {
  [x: string]: any;
  suppliesNeededItemList: MasterLookupDTO[] = [];
  settingData: any;
  submitButton: boolean = true;
  isDialogShow: boolean = false;
  newItemDescription: string = '';
  masterLookup!: MasterLookupDTO;
  userData: any;
  isEdit = false;
  constructor(
      public config: DynamicDialogConfig,
      public dialogService: DialogService,
      public ref: DynamicDialogRef,
      private operationService: OperationService,
      private lookupService: LookupService,
      private messageService: MessageService,
      private storage: WebStorage,
      private confirmationService: ConfirmationService
  ) {
      this.settingData = this.config;

}
ngOnInit() {
  this.userData = this.storage.getUserData();
  this.masterLookup = {
    description: undefined,
    id: undefined,
    lastModified: undefined,
    lastModifiedBy: undefined,
    name: undefined,
    schoolId: this.userData.schoolId,
    status: 'A',
    type: 'Supply Needed',
    value: undefined,
    valueTwo: undefined,
  }
  if (this.settingData.header === 'Add Item') {
      this.queryData();
  } else {
      this.queryData();
  }
  this.suppliesNeededItemList = [];

}
queryData() {
  this.lookupService
      .queryMasterLookups({
          'userData.equals': 1,
          'type.equals':'Supply Needed',
          'status.equals' : 'A',
          sort: 'name,asc'
      })
      .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
          this.suppliesNeededItemList = res.body ?? [];
      });


}
onRowEditInit(supply: MasterLookupDTO) {
  this.masterLookup = { ...supply };
  this.isEdit = true;
  this.isDialogShow = true;
}
updateRowValues() {

  const rowIndex = this.suppliesNeededItemList.findIndex(item => item.id === this.masterLookup.id);


  if (rowIndex !== -1) {
    this.suppliesNeededItemList[rowIndex] = { ...this.masterLookup };
  }
}

addItem(){
  this.isEdit = false;
  this.isDialogShow = true;
  this.masterLookup = {
    description: undefined,
    id: undefined,
    lastModified: undefined,
    lastModifiedBy: undefined,
    name: undefined,
    schoolId: this.userData.schoolId,
    status: 'A',
    type: 'Supply Needed',
    value: undefined,
    valueTwo: undefined,
  }
}
hideDialog() {
  this.isDialogShow = false;
  this.newItemDescription = '';
}
save(){

  this.masterLookup.name = this.masterLookup.value;
  if(this.masterLookup.id != undefined && this.masterLookup.id != null){
    this.subscribeToSaveResponse(
      this.operationService.updateMasterLookups(
          this.masterLookup));
  }else {
    this.subscribeToSaveResponse(
      this.operationService.createMasterLookups(
          this.masterLookup));
  }
}

protected subscribeToSaveResponse(
  result: Observable<HttpResponse<MasterLookupDTO>>
): void {
  result.subscribe(
      (result) => this.onSaveSuccess(result.body),
      (error) => this.onSaveError(error)
  );
}
protected onSaveSuccess(res: MasterLookupDTO | null): void {

  if (this.masterLookup.id != undefined && this.masterLookup.id != null) {
      this.isDialogShow = false;
      this.messageService.add({
          severity: 'success', 
          life: 3000,
          summary: 'Success',
          detail: 'Manage Item updated successfully.',
      });
  } else {
    this.isDialogShow = false;
      this.messageService.add({
          severity: 'success', 
          life: 3000,
          summary: 'Success',
          detail: 'Manage Item added successfully.',
      });
  }
  this.queryData();

}

onSaveError(error: any): void {
  this.messageService.add({
      severity: 'error', 
      life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
  });
}

onRowEditSave(item: any) {
  item.isSuppliesNeededItemList = true;
  item.userData.schoolId = 1;
  item.status = 'A';
  if (item.name || item.rate) {
      this.operationService.updateMasterLookups(item).subscribe(
          (res: HttpResponse<MasterLookupDTO>) => {
              this.messageService.add({
                  key: 'item',
                  severity: 'success',  
                  summary: 'Success',
                  detail: `Supply Item Updated successfully.`,
                  life: 3000,
              });
              this.queryData();
          },
          (error) => {
              this.messageService.add({
                  severity: 'error', 
                  life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
              });
          }
      );
  }
}
onRowEditCan(item: MasterLookupDTO, index: number) {
  this.isDialogShow = false;

}

onRowEditCancel(item: MasterLookupDTO, index: number,event : Event) {
  document.documentElement.style.setProperty('--maskbg', '#d19597a5');
  this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Do you want to delete this item - " '+ item.value +' " ?',
      header: 'Delete item',
      acceptLabel: 'Yes, Delete',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      acceptButtonStyleClass:'p-button-danger p-button-raised',
      rejectButtonStyleClass: 'p-button-secondary p-button-raised',
      defaultFocus: 'none',
      accept: () => this.deleteDose(item,index),
      reject: () => {
        document.documentElement.style.setProperty(
        '--maskbg',
        'rgba(0, 0, 0, 0.4)'
    );
      },
  });


}



deleteDose(item: MasterLookupDTO, index: number) {
  if(item.id != undefined){
    item.status = 'I';
    this.operationService.updateMasterLookups(item).subscribe((res : HttpResponse<MasterLookupDTO>)=>{
      this.messageService.add({
        severity: 'success', 
        life: 3000,
        summary: 'Success',
        detail: `Supply Item Deleted successfully.`,
    });
    document.documentElement.style.setProperty(
      '--maskbg',
      'rgba(0, 0, 0, 0.4)'
  );
    this.queryData();
    },
    (error) => {
        this.messageService.add({
            severity: 'error', 
            life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
        });
    })

  }else{
    this.suppliesNeededItemList.splice(index,1);
  }

}
onCloseDialog(){

  this.hideDialog();
}
}
